wbApp.controller('StudentAmortizationScheduleCtrl', ['$scope', 'coursePriceSvc',
    function ($scope, coursePriceSvc) {

        $scope.amortizationSchedules = coursePriceSvc.calculateAmortizationSchedules(
            $scope.model.invoice.total,
            $scope.model.registrationDate || moment().toDate(),
            $scope.amortizationScheduleTemplates);
    }]);
